import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { get } from "lodash";
import { Link, useHistory } from "react-router-dom";
import { FormGroup, Button } from "reactstrap";
import { LocalForm, Control } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import SaveButton from "components/common/Forms/SaveButton";
import { useClient } from "hooks";

export default function Login({setRegister, app, tokeInfo}) {
  
    const { t } = useTranslation();
    const client = useClient();
    const [form, setForm] = useState();
    let history = useHistory();
  
    async function onSubmit({ email, password }) {
        try {
          await client.post("/auth", {
            email: email.toLowerCase(),
            password,
          });
          // Launch that app setup
          window.location.reload();
          NotificationManager.success(t("Connected Successfully"));
    
        } catch (err) {
          if (get(err, "response.status") === 400) {
            NotificationManager.error(t("Invalid username or password"));
          } else {
            NotificationManager.error(t("Unable to log in at this time"));
          }
          err.handled = true;
          throw err;
        }
      }

    return (
        <div className="m-auto text-center py-1">
            <div id="contact-form-1 my-3">
                <p className="log-text" />
                <LocalForm
                    initialState={{ 'email': '', 'password': '' }}
                    onSubmit={onSubmit}
                    onUpdate={setForm}
                    className="contactForm"
                >
                    <FormGroup style={{ marginBottom: "1rem" }}>
                        <Control.text
                            model=".email"
                            type="email"
                            className="form-control rounded"
                            placeholder={t("Email Address")}
                            required
                        />
                    </FormGroup>
                    <FormGroup style={{ marginBottom: "1rem" }}>
                        <Control.text
                            model=".password"
                            type="password"
                            className="form-control rounded"
                            placeholder={t("Password")}
                            required
                        />
                    </FormGroup>
                    {form && (
                        <SaveButton
                            type="submit"
                            id="form-submit"
                            form={form}
                            className="btn-primary-filled btn-rounded btn-form-submit btn-rounded mx-0 w-100 my-2"
                        >
                            {/* <i className="fa fa-sign-in" aria-hidden="true"></i>  */}
                            <Trans>Sign in</Trans>
                        </SaveButton>

                    )}
                </LocalForm>
                <Link className="small" to="/forgotten_password" style={{ textDecoration: "none", color: "#72B566" }}>
                    <Trans>Forgotten your password?</Trans>
                </Link><br />
                {/* small form-text text-end */}
                <span className="small">
                    <span className="mx-1"><Trans>Don’t have an account?</Trans></span><Link onClick={(e) => {e.preventDefault(); setRegister(true)}} style={{ color: "#72B566" }}><Trans>Create an Account</Trans></Link>
                </span>
            </div>
        </div>
    )
}